import React from 'react'

import { parseMessageText } from '../message-helpers'
import { useMessageProperties } from '../message-provider'
import { convertRichTextToPlainText } from '~utils/helpers'
import MentionText from '~components/shared/text/mention-text'
import MaybeMissingText from '~components/shared/texts/maybe-missing-text'

export default function MessageText() {
    const { message, chat, isCurrentUser, noTail, noHead } =
        useMessageProperties()

    if (!message.text && !message.email_text) return null

    const bodyText =
        message.text ||
        convertRichTextToPlainText(message.email_text || '') ||
        ''

    // Internal notes are the only place teammates can `@`-mention each
    // other today, so only run the mention parser there. Outbound client
    // messages keep the existing `parseMessageText` linkifier untouched
    // (the mention markup itself would never appear in them).
    return (
        <MaybeMissingText whiteSpace="pre-wrap">
            {message.hidden_for_client ? (
                <MentionText text={bodyText} />
            ) : (
                parseMessageText({ text: bodyText })
            )}
        </MaybeMissingText>
    )
}
